import script from "./HistoricalChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoricalChart.vue?vue&type=script&setup=true&lang=ts"

import "./HistoricalChart.vue?vue&type=style&index=0&id=b36186be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b36186be"]])

export default __exports__